import { FC } from 'react';
import cx from 'classnames';

import { Layout } from 'components/common';

export const Home: FC = () => (
  <Layout className={cx('content', 'content--with-padding')}>Home page</Layout>
);
